$(() => {
  // map_availableが変更された場合の活性・非活性処理
  $('.js-shop-map-available').on('change', e => {
    if ($(e.currentTarget).is(':checked')) {
      $('.js-lat,.js-lng').attr('disabled', false).removeClass('disabled');
    } else {
      $('.js-lat,.js-lng').attr('disabled', true).addClass('disabled');
    }
  });

  // 緯度経度の値が変更された場合の活性・非活性処理
  $('.js-lat,.js-lng').on('change', () => {
    if ($('.js-lat').val().length === 0 || $('.js-lng').val().length === 0) {
      $('.js-get-nearest-station').attr('disabled', true).addClass('disabled');
    } else {
      $('.js-get-nearest-station').attr('disabled', false).removeClass('disabled');
    }
  });
});
